export default __webpack_public_path__ + "static/media/dra-silvia-wasserstein.7dff6393.png";